/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HtmlWrapperVo
 */
export interface HtmlWrapperVo {
    /**
     * html内容
     * @type {string}
     * @memberof HtmlWrapperVo
     */
    html?: string;
}

/**
 * Check if a given object implements the HtmlWrapperVo interface.
 */
export function instanceOfHtmlWrapperVo(value: object): value is HtmlWrapperVo {
    return true;
}

export function HtmlWrapperVoFromJSON(json: any): HtmlWrapperVo {
    return HtmlWrapperVoFromJSONTyped(json, false);
}

export function HtmlWrapperVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HtmlWrapperVo {
    if (json == null) {
        return json;
    }
    return {
        
        'html': json['html'] == null ? undefined : json['html'],
    };
}

export function HtmlWrapperVoToJSON(json: any): HtmlWrapperVo {
    return HtmlWrapperVoToJSONTyped(json, false);
}

export function HtmlWrapperVoToJSONTyped(value?: HtmlWrapperVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'html': value['html'],
    };
}

